export default {
  props: {
    tabView: null,
    id: null
  },
  computed: {
    tableInOnlineMode () {
      return this.$route.params.id
    },
    enableOnAdd () {
      return ['fkkoName', 'code', 'total', 'count']
    },
    operatorAttr () {
      return {
        garbageGroupName: {
          label: 'Группа отходов',
          validationRulePattern: '(\\.*)',
          placeholder: 'Введите название отхода',
          required: true,
          suggestion: {
            useInnerSearch: true,
            minSuggestLen: 0,
            options: [],
            onSelect: this.onSelectGarbageGroup,
            suggestionEndpoint: this.suggestionEndpointGarbageGroup,
            transformSuggestions: this.transformSuggestionsGarbageGroup
          }
        },
        tkoOperatorServiceName: {
          label: 'Обслуживающий оператор/Рег. оператор',
          validationRulePattern: '(\\.*)',
          placeholder: 'Введите название оператора',
          suggestion: {
            useInnerSearch: true,
            options: [],
            onSelect: this.onSelectOperatorService,
            suggestionEndpoint: this.suggestionEndpointOperatorService,
            transformSuggestions: this.transformSuggestionsOperatorService
          }
        },
        tkoOperatorTransportName: {
          label: 'Транспортировщик',
          validationRulePattern: '(\\.*)',
          placeholder: 'Введите название транспортировщика',
          suggestion: {
            useInnerSearch: true,
            options: [],
            onSelect: this.onSelectOperatorTransport,
            suggestionEndpoint: this.suggestionEndpointOperatorTransport ,
            transformSuggestions: this.transformSuggestionsOperatorTransport
          }
        },
        tkoObjectName: {
          label: 'Объект транспортирования',
          validationRulePattern: '(\\.*)',
          placeholder: 'Введите название объекта',
          suggestion: {
            useInnerSearch: true,
            options: [],
            onSelect: this.onSelectObject,
            suggestionEndpoint: this.suggestionEndpointObject,
            transformSuggestions: this.transformSuggestionsObject
          }
        },
        address: {
          label: 'Местоположение объекта',
          validationRulePattern: '(\\.*)',
          placeholder: ' ',
          disabled: true
        }
      }
    },
    operatorDataUrl () {
      return null
    },
    medGarbageClass () {
      if (this.$store.getters.readUrlEndpoint(this.getMedGarbageClassEndpoint())) {
        return this.$store.getters.readUrlEndpoint(this.getMedGarbageClassEndpoint()).med_garbage_class
      }
      return []
    }
  },
  methods: {
    suggestionEndpointObject (ctx, q) {
      return null
    },
    operatorPostUrl (context, model) {
      return null
    },
    operatorPatchUrl (context, model) {
      return null
    },
    operatorDeleteUrl (context, model) {
      return null
    },
    suggestionEndpointGarbageGroup (ctx, q) {
      return null
    },
    suggestionEndpointOperatorService (ctx, q) {
      return null
    },
    suggestionEndpointOperatorTransport (ctx, q) {
      return null
    },
    afterValidate (ctx, model, errors, els) {
      if (model.tkoOperatorServiceName && model.tkoOperatorServiceName.length > 1 && !model.tko_operator_service_id) {
        errors.tkoOperatorServiceName = 'Неверно заполнено поле'
      }
      if (model.tkoOperatorTransportName && model.tkoOperatorTransportName.length > 1 && !model.tko_operator_transport_id) {
        errors.tkoOperatorTransportName = 'Неверно заполнено поле'
      }
      if (model.tkoObjectName && model.tkoObjectName.length > 1 && !model.tko_object_id) {
        errors.tkoObjectName = 'Неверно заполнено поле'
      }
      return errors
    },
    onSelectObject (ctx, $event, model, attr) {
      if ($event && $event.id) {
        let copy = Object.assign({}, $event)
        model.tko_object_id = copy.id
        model.tkoObjectName = copy.tkoObjectName
        model.address = copy.address
      } else {
        model.address = ''
        model.tko_object_id = ''
        model.tkoObjectName = ''
      }
    },
    transformSuggestionsObject (ctx, response) {
      let data = response.data
      let options = []
      for (let i = 0; i < data.length; i++) {
        options.push({
          name: data[i].name,
          tkoObjectName: data[i].name,
          id: data[i].id,
          address: data[i].address
        })
      }
      return options
    },
    onSelectOperatorTransport (ctx, $event, model, attr) {
      if ($event && $event.id) {
        let copy = Object.assign({}, $event)
        model.tko_operator_transport_id = copy.id
        model.tkoOperatorTransportName = copy.tkoOperatorTransportName
      } else {
        model.tko_operator_transport_id = ''
        model.tkoOperatorTransportName = ''
      }
    },
    transformSuggestionsOperatorTransport (ctx, response) {
      let data = response.tko_operator_transport
      let options = []
      for (let i = 0; i < data.length; i++) {
        options.push({
          name: data[i].name,
          tkoOperatorTransportName: data[i].name,
          id: data[i].id
        })
      }
      return options
    },
    onSelectOperatorService (ctx, $event, model, attr) {
      if ($event && $event.id) {
        let copy = Object.assign({}, $event)
        model.tko_operator_service_id = copy.id
        model.tkoOperatorServiceName = copy.tkoOperatorServiceName
      } else {
        model.tko_operator_service_id = ''
        model.tkoOperatorServiceName = ''
      }
    },
    transformSuggestionsOperatorService (ctx, response) {
      let data = response.tko_operator
      let options = []
      for (let i = 0; i < data.length; i++) {
        options.push({
          name: data[i].name,
          tkoOperatorServiceName: data[i].name,
          id: data[i].id
        })
      }
      return options
    },
    onSelectGarbageGroup (ctx, $event, model, attr) {
      if ($event && $event.id) {
        let copy = Object.assign({}, $event)
        model.garbage_group_id = copy.id
        model.garbageGroupName = copy.garbageGroupName
      } else {
        model.garbage_group_id = ''
        model.garbageGroupName = ''
      }
    },
    transformSuggestionsGarbageGroup (ctx, response) {
      let data = response.garbage_group
      let options = []
      for (let i = 0; i < data.length; i++) {
        options.push({
          name: data[i].name,
          garbageGroupName: data[i].name,
          id: data[i].id
        })
      }
      return options
    },
    afterFetchData (ctx, data) {
      for (let i = 0; i < data.data.length; i++) {
        if (!data.data[i].hasOwnProperty('garbageGroupName')) {
          data.data[i].garbageGroupName = ''
        }
        if (!data.data[i].hasOwnProperty('garbage_group_id')) {
          data.data[i].garbage_group_id = ''
        }
        if (!data.data[i].hasOwnProperty('tkoOperatorServiceName')) {
          data.data[i].tkoOperatorServiceName = ''
        }
        if (!data.data[i].hasOwnProperty('tkoOperatorTransportName')) {
          data.data[i].tkoOperatorTransportName = ''
        }
        if (!data.data[i].hasOwnProperty('tkoObjectName')) {
          data.data[i].tkoObjectName = ''
        }
        if (!data.data[i].hasOwnProperty('address')) {
          data.data[i].address = ''
        }

        if (data.data[i].garbageGroup) {
          data.data[i].garbageGroupName = data.data[i].garbageGroup.name
        }
        if (data.data[i].tkoOperatorService) {
          data.data[i].tkoOperatorServiceName = data.data[i].tkoOperatorService.name
        }
        if (data.data[i].tkoOperatorTransport) {
          data.data[i].tkoOperatorTransportName = data.data[i].tkoOperatorTransport.name
        }
        if (data.data[i].tkoObject) {
          data.data[i].tkoObjectName = data.data[i].tkoObject.name
          data.data[i].address = data.data[i].tkoObject.address
        }
      }
      return data
    },
    addNewRowToTable () {
      this.$refs.operator.createRow({
        tkoOperatorServiceName: '',
        tkoOperatorTransportName: '',
        tkoObjectName: '',
        address: '',
        garbageGroupName: 'ТКО',
        garbage_group_id: 1
      })
    }
  }
}
